export default "__VITE_ASSET__iezZun49__"